module.exports = __webpack_public_path__ + "img/cambodia.25d97d74.svg";